module.exports = __webpack_public_path__ + "img/head_bg1.5102d943.png";